import { NgModule } from '@angular/core';
import { NavigationEventBuilder } from './navigation-event.builder';

@NgModule({})
export class NavigationEventModule {
  constructor(_navigationEventBuilder: NavigationEventBuilder) {}
}
